// 서버 응답 코드
export const RC = {
  // 성공
  SUCCESS: 'SUCCESS',

  // 클라이언트 에러
  BAD_REQUEST: 'BAD_REQUEST',

  // 인증 에러
  UNAUTHORIZED: 'UNAUTHORIZED',
  INVALID_TOKEN: 'INVALID_TOKEN',
  EXPIRED_TOKEN: 'EXPIRED_TOKEN',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  AUTHENTICATION_FAILED: 'AUTHENTICATION_FAILED',

  // 권한 에러
  FORBIDDEN: 'FORBIDDEN',

  // 리소스 에러
  NOT_FOUND: 'NOT_FOUND',

  // 충돌 에러
  CONFLICT: 'CONFLICT',

  // 요청 제한 에러
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',

  // 서버 에러
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
} as const

export type ResponseCode = (typeof RC)[keyof typeof RC]
